// File: src/components/potus/SectorDropdown.jsx
import React from 'react';
import { 
  FormControl, 
  Select, 
  MenuItem, 
  InputLabel,
  Box
} from '@mui/material';
import { SECTOR_LIST } from '../../utils/constants';

const SectorDropdown = ({ selectedSector, onSectorChange }) => {
  const handleChange = (event) => {
    const newSector = event.target.value;
    onSectorChange(newSector);
  };

  return (
    <Box sx={{ minWidth: 200, mb: 2 }}>
      <FormControl fullWidth size="small">
        <InputLabel id="sector-select-label">Select Sector</InputLabel>
        <Select
          labelId="sector-select-label"
          id="sector-select"
          value={selectedSector}
          label="Select Sector"
          onChange={handleChange}
        >
          {SECTOR_LIST.map((sector) => (
            <MenuItem 
              key={sector} 
              value={sector}
            >
              {sector}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SectorDropdown;